//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

import DefaultCampaignCard from 'components/advertising/overview/DefaultCampaignCard';
import NumbersCard from 'components/analytics/NumbersCard';
import AnalyticsChartCard from 'components/analytics/AnalyticsChartCard';


export default {
	name: 'AdvertisingDetailPage',

	components: {
		DefaultCampaignCard,
		NumbersCard,
		AnalyticsChartCard,
	},

	data: () => ({
		loading: true,
	}),

	computed: {
		...mapState('advertising', ['defaultCampaign']),
		...mapState('advertising', [
			'campaignStatsData',
			'impressionSum',
			'impressionChart',
			'clickSum',
			'clickChart',
		]),
		canShowStats() {
			return Object.keys(this.campaignStatsData).length > 0;
		},
		leads() {
			if (!this.canShowStats) return 0;
			const stat = this.campaignStatsData.actions.find(a => a.action_type === 'lead');
			const { value } = stat || 0;
			return parseInt(value || 0);
		},
		phoneClicks() {
			if (!this.canShowStats) return 0;
			const stat = this.campaignStatsData.actions.find(a => a.action_type === 'onsite_conversion.click_to_call');
			const { value } = stat || 0;
			return parseInt(value || 0);
		},
	},

	async created() {
		if (!this.defaultCampaign.id) return this.$router.push('/advertising');
		await this.$store.dispatch('advertising/getCampaign', this.defaultCampaign.id);
		this.loading = false;
	},

};
